import React from 'react'

const Footer = () => {
  return (
    <footer>
      <p>Copyright &copy; 2023</p>
      
    </footer>
  )
}

export default Footer